import { instance } from '@/services/api/index';

export const adminService = {
  // Produktbild hochladen
  uploadProductImage(productId, file) {
    const formData = new FormData();
    formData.append('file', file);
    
    return instance.post(`/Products/${productId}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Produktpreis aktualisieren
  updateProductPrice(productId, price) {
    return instance.patch(`/Products/${productId}/price`, { price });
  },
  
  // Alle Produkte abrufen
  getProducts() {
    return instance.get('/Products');
  },
  
  // Alle Kategorien abrufen
  getCategories() {
    return instance.get('/Categories');
  },
  
  // Produkt löschen
  deleteProduct(productId) {
    return instance.delete(`/Products/${productId}`);
  },
  
  getTable(tableId) {
    return instance.get(`/Tables/${tableId}`);
  },

  // Bestellungen eines Tisches mit optionalem Zeitfilter und Pagination
  getOrdersForTable(tableId, params = {}) {
    return instance.get(`/orders/table/${tableId}`, { params });
  },
  
  // Benutzer-Verwaltung
  async getUsers(params = {}) {
    const response = await instance.get('/Users', { params });
    return { data: response.data };
  },
  
  async getUser(id) {
    const response = await instance.get(`/Users/${id}`);
    return { data: response.data };
  },
  
  async createUser(data) {
    const response = await instance.post('/Users', data);
    return { data: response.data };
  },
  
  async updateUser(id, data) {
    const response = await instance.put(`/Users/${id}`, data);
    return { data: response.data };
  },
  
  async deleteUser(id) {
    return instance.delete(`/Users/${id}`);
  }
}; 